
























import Vue from 'vue'
import { LanguagePickerInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'LanguagePickerEl',

  mounted () {
    this.selected = this.templateItemData.selectedValue
  },

  data: () => ({
    selected: ''
  }),

  props: {
    templateItemData: {
      type: Object as () => LanguagePickerInterface,
      required: true
    }
  },
  methods: {
    handleLanguageChange (val:string) {
      sessionStorage.setItem(process.env.VUE_APP_HEADER_LANGUAGE, val)
      window.location.reload()
    }
  }
})
